import React from 'react';
import Src from './Src';
import RoundCircle from './RoundCircle';

const ImageComponent = () => {
    return (
         <div className="m-3">
         <h3>Images</h3>
         <p>Use images having different sizes, shapes and borders.</p>
         <Src />
         <RoundCircle />
       </div>
    )
}

export default ImageComponent
